import axios from 'axios';

  export const fetchWalletAmount = async (customer_id, token) => {
    try {
      const data = JSON.stringify({
        query: `query FetchWalletAmount($input: FetchWalletAmountInput!) {
          FetchWalletAmount(input: $input) {
            walletamount
            status
            message
          }
        }`,
        variables: { input: { customer_id } }
      });

      const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://mcstaging.candere.com/graphql',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        withCredentials: true,
        data: data
      };

      const response = await axios.request(config);
      return response.data;

    } catch (error) {
      console.error("Failed to fetch wallet amount:", error);
      return null;
    }
};
